var _rect, _path, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 16,
    height: 7,
    fill: "#737373"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 29H32V34V36H30H25V29Z",
    fill: "#737373"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 7,
    height: 7,
    fill: "#737373"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29,
    width: 7,
    height: 7,
    fill: "#737373"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 7,
    height: 7,
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 42H12C10.8 42 10 41.2 10 40V7C10 5.8 10.8 5 12 5H36C37.2 5 38 5.8 38 7V33C38 33.6 38.4 34 39 34C39.6 34 40 33.6 40 33V7C40 4.8 38.2 3 36 3H12C9.8 3 8 4.8 8 7V40C8 42.2 9.8 44 12 44H30C30.6 44 31 43.6 31 43C31 42.4 30.6 42 30 42Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 39L43 47L35 39Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 39L43 47",
    stroke: "#E52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 39L35 47L43 39Z",
    fill: "#737373"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39L35 47",
    stroke: "#E52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItems);
export default __webpack_public_path__ + "static/media/no-items.adca066bf8a3d73c80628af256a42739.svg";
export { ForwardRef as ReactComponent };